import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useRef,
    useState,
} from "react";
import classes from "./ViewerProps.module.css";
import ViewerPropsRow from "./ViewerPropsRow";
import {
    useAppDispatch,
    useAppSelector,
    useViewer,
} from "../../../app/hooks/hooks";
import {
    selectViewerPropsVisibility,
    toggleViewerPropsVisibility,
} from "../../../app/features/viewer/buttonsSlice/buttonsSlice";
import { useGetParamsByIdMutation } from "../../../app/services/params/params";
import { PropData } from "bimatter-viewer/dist/Model/Model.types";
import TreePropsInput from "../../Inputs/TreePropsInput/TreePropsInput";
import ViewerPropsSetTitle from "./ViewerPropsSetTitle";
import { selectSetsNotActive } from "../../../app/features/viewer/propsSlice/propsSlice";
interface ViewerPropsParams {}
function ViewerProps({}: ViewerPropsParams) {
    const viewerPropsVisibility = useAppSelector(selectViewerPropsVisibility);
    const setsNotActive = useAppSelector(selectSetsNotActive);
    const viewer = useViewer();
    const width = 400;
    const dispatch = useAppDispatch();
    const [getParamsById] = useGetParamsByIdMutation();

    const [curParams, setCurParams] = useState<PropData | null>(null);
    const [search, setSearch] = useState("");
    async function showPropsOverrider(modelID?: number, id?: number) {
        if (modelID === undefined || id === undefined) {
            setCurParams(null);
        } else {
            const isServerSide =
                !viewer?.models[modelID].properties.hasProperties;
            let props;
            if (isServerSide) {
                props = await getParamsById({
                    modelID,
                    id,
                }).unwrap();
            } else {
                props = viewer?.models[modelID].properties.data[id];
            }
            setCurParams(props);
        }
        const selectionTriggerEvent = new CustomEvent("selectionTrigger", {
            detail: {},
        });
        viewer?.container.dispatchEvent(selectionTriggerEvent);
        // return props;
    }

    useEffect(() => {
        if (viewer && viewerPropsVisibility) {
            viewer.utils.propsUtils.useDefaultGetPropertiesById = false;
            viewer.utils.propsUtils.setGetParamsByIdOverride(
                showPropsOverrider,
                true
            );
        }
        return () => {
            viewer?.utils.propsUtils.setGetParamsByIdOverride(() => {
                const selectionTriggerEvent = new CustomEvent(
                    "selectionTrigger",
                    {
                        detail: {},
                    }
                );
                viewer?.container.dispatchEvent(selectionTriggerEvent);
            });
        };
    }, []);
    function getParamValue(param: any, isQuantities: boolean) {
        let paramValue;
        if (isQuantities) {
            if (param.LengthValue) {
                paramValue = Math.round(param.LengthValue * 100) / 100;
            } else if (param.WeightValue) {
                paramValue = Math.round(param.WeightValue * 100) / 100;
            } else if (param.VolumeValue) {
                paramValue = Math.round(param.VolumeValue * 100) / 100;
            } else if (param.AreaValue) {
                paramValue = Math.round(param.AreaValue * 100) / 100;
            }
        } else {
            paramValue = param.NominalValue;
        }
        return paramValue;
    }
    const checkIsSearch = (name: string, value: string | boolean | number) => {
        if (!search) return false;
        return (
            name.toLowerCase().includes(search.toLowerCase()) ||
            value.toString().toLowerCase().includes(search.toLowerCase())
        );
    };
    const isMobile =
        viewer?.utils.osUtils.OS === "Android" ||
        viewer?.utils.osUtils.OS === "IOS";
    if (!curParams) return <></>;
    return (
        <div className={classes.paramsWindowWrap} style={{ width: width }}>
            {isMobile && (
                <div
                    className={classes.exitBut}
                    onClick={() => {
                        if (!viewer) return;
                        for (const model_id of Object.keys(viewer.models))
                            viewer.selector.selection.selectByIds(
                                Number(model_id),
                                [],
                                true
                            );
                    }}
                >
                    +
                </div>
            )}
            <div className={classes.header}>Properties panel</div>
            <TreePropsInput search={search} setSearch={setSearch} />
            <div className={classes.paramsWindowScrollWrap}>
                <div className={classes.setWrap}>
                    <ViewerPropsSetTitle
                        hidden={setsNotActive.includes(
                            "Element identificators"
                        )}
                    >
                        {"Element identificators"}
                    </ViewerPropsSetTitle>
                    {!setsNotActive.includes("Element identificators") && (
                        <>
                            <ViewerPropsRow
                                paramName="guid"
                                value={curParams.guid}
                                isSearched={checkIsSearch(
                                    "guid",
                                    curParams.guid
                                )}
                            ></ViewerPropsRow>
                            <ViewerPropsRow
                                paramName="id"
                                value={curParams.id}
                                isSearched={checkIsSearch("id", curParams.id)}
                            ></ViewerPropsRow>
                        </>
                    )}
                </div>

                <div className={classes.setWrap}>
                    <ViewerPropsSetTitle
                        hidden={setsNotActive.includes("Element parameters")}
                    >
                        {"Element parameters"}
                    </ViewerPropsSetTitle>
                    {!setsNotActive.includes("Element parameters") &&
                        Object.keys(curParams.props).map(
                            (paramName: string, i) => {
                                const val = curParams.props[paramName];
                                return (
                                    <ViewerPropsRow
                                        key={`${i}_${paramName}`}
                                        paramName={paramName}
                                        value={val}
                                        isSearched={checkIsSearch(
                                            paramName,
                                            val
                                        )}
                                    ></ViewerPropsRow>
                                );
                            }
                        )}

                    {curParams.tprops && (
                        <div className={classes.setWrap}>
                            <ViewerPropsSetTitle
                                hidden={setsNotActive.includes(
                                    "Type parameters"
                                )}
                            >
                                {"Type parameters"}
                            </ViewerPropsSetTitle>

                            {!setsNotActive.includes("Type parameters") &&
                                Object.keys(curParams.tprops).map(
                                    (paramName: string, i) => {
                                        const val = curParams.props[paramName];
                                        return (
                                            <ViewerPropsRow
                                                key={`${i}_${paramName}`}
                                                paramName={paramName}
                                                value={
                                                    curParams.props[paramName]
                                                }
                                                isSearched={checkIsSearch(
                                                    paramName,
                                                    val
                                                )}
                                            ></ViewerPropsRow>
                                        );
                                    }
                                )}
                        </div>
                    )}
                </div>
                {curParams.sets &&
                    curParams.sets.map((set: any, i) => {
                        const hidden = setsNotActive.includes(set.name);
                        return (
                            <div
                                key={`${i}_${set.name}`}
                                className={classes.setWrap}
                            >
                                <ViewerPropsSetTitle hidden={hidden}>
                                    {set.name}
                                </ViewerPropsSetTitle>
                                {set.props.map((prop: any) => {
                                    if (!hidden) {
                                        const val = getParamValue(
                                            prop,
                                            set.isQuantities
                                        );
                                        return (
                                            <ViewerPropsRow
                                                key={`${i}_${set.name}_${prop.Name}`}
                                                paramName={prop.Name}
                                                value={val}
                                                isSearched={checkIsSearch(
                                                    prop.Name,
                                                    val
                                                )}
                                            ></ViewerPropsRow>
                                        );
                                    } else {
                                        return <></>;
                                    }
                                })}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
}

export default ViewerProps;

// if (propSets && propSets.length) {
//     for (const set of propSets) {
//         const params = document.createElement("div");
//         params.innerHTML = set.name;
//         this.propConteiner?.appendChild(params);
//         for (const param of set.props) {
//             const paramName = param.Name;
//             let paramValue;
//             if (param.isQuantities) {
//                 if (props.LengthValue) {
//                     paramValue =
//                         Math.round(props.LengthValue * 100) / 100;
//                 } else if (props.WeightValue) {
//                     paramValue =
//                         Math.round(props.WeightValue * 100) / 100;
//                 } else if (props.VolumeValue) {
//                     paramValue =
//                         Math.round(props.VolumeValue * 100) / 100;
//                 } else if (props.AreaValue) {
//                     paramValue =
//                         Math.round(props.AreaValue * 100) / 100;
//                 }
//             } else {
//                 paramValue = param.NominalValue;
//             }
//             const row = document.createElement("div");
//             this.propConteiner!.appendChild(row);
//             row.style.display = "flex";
//             row.style.justifyContent = "center";
//             row.style.flexDirection = "row";
//             const paramNameDiv = document.createElement("div");
//             paramNameDiv.style.marginRight = "5px";
//             const paramValueDiv = document.createElement("div");
//             row.appendChild(paramNameDiv);
//             row.appendChild(paramValueDiv);
//             paramNameDiv.innerHTML = paramName + ": ";
//             paramValueDiv.innerHTML = paramValue ? paramValue : "";
//         }
//     }
// }
